export const defaultSort = 'created_at-desc'
export const defaultPage = 0
export const defaultLimit = 50
